import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import { numberWithCommas } from "../../core/utils";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    image?: any;
    myStyle?: string;
    colorFull?: boolean;
    countTitle: string;
    countValue: string;
    headLineTitle: string;
    badge?:string;
    children?:ReactElement;
}

export function TotalCard({ image, myStyle, colorFull, countTitle, countValue, headLineTitle , children}: Props): ReactElement {

    const textColor = colorFull ? "text-white" : "text-dark";
    return (
        <div className={`total-card ${myStyle && myStyle} ${colorFull ? "bg-green" : "bg-white"}`}>
            <div className="head-line">
                <div className="right-side">
                    <div className={`${colorFull ? "bg-light-green2" : "bg-light-blue"} icon-container`}>
                        {image}
                    </div>
                    <span className={`${textColor} title`}> {headLineTitle}  </span>
                </div>

                {children}
            </div>
            <div className="count">
                <span className={`${textColor} value`}>
                    {numberWithCommas(countValue)}
                </span>
                <span className={`${textColor} title`}>
                    {countTitle}
                </span>
            </div>
        </div>
    )
}

export default TotalCard;